import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))

const AiModelSettingWrapper = lazy(() => import('./AiModelSettingWrapper'))

class AiModelSettingComponent extends ReactWebComponent {
	override render() {
		return (
			<RootProviders>
				<AiModelSettingWrapper />
			</RootProviders>
		)
	}
}

customElements.define('ai-model-setting', AiModelSettingComponent)
